import { useSystemStore } from "components/PageHeader/systemStore";
import Image from "next/image";
import React from "react";

type Props = {
    icon: string;
    size?: number;
}

export const IconLeaderboard: React.FC<Props> = ({
    icon = "/images/leaderboard-outline.png",
    size = 24,
}) => {
    const theme = useSystemStore((state) => state.theme);

    return (
        <Image
            alt="leaderboard"
            src={icon}
            width={size}
            height={size}
            className={theme === "dark" ? "invert brightness-0" : ""}
        />
    )
}
